// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2ggUR","footer":"ReportModalFilter_footer__XHOcq"};